module.exports = __webpack_public_path__ + "static/media/confirmacao2.3f6056de.svg";